export const BalanceReportTypes = {
    GET_BALANCE_REPORT:'GET_BALANCE_REPORT',
}